module.exports = __webpack_public_path__ + "img/indomaret-logo.2a2c6afd.png";